import React, { useCallback, useMemo } from "react";

import { Checkbox } from "@app/scripts/react-general-components/Checkbox";

import type { FilterListProps, Swatches } from "@app/scripts/types";

type Props = FilterListProps & { swatches: Swatches; className?: string };

export const FilterListSwatch: React.FC<Props> = (props) => {
  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      props.filterListProps.handleChange(event.target.value);
    },
    [props.filterListProps]
  );

  let sortedOptions = [...props.filterListProps.options]

  if (props.filter.handle === "colour") {
    const options = props.filterListProps.options?.filter(option => !option.checked)
    const checkedOptions = props.filterListProps.options?.filter(option => option.checked).sort()
    sortedOptions = [...checkedOptions, ...options]
  }

  return (
    <div className={props.className}>
      {sortedOptions.map((option) => (
        <CheckboxSwatch key={option.key} option={option} onChange={onChange} swatches={props.swatches} />
      ))}
    </div>
  );
};

type CheckboxSwatchProps = {
  option: any;
  swatches: Swatches;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const CheckboxSwatch: React.FC<CheckboxSwatchProps> = (props) => {
  const swatch = useMemo(() => {
    return props.swatches?.find(
      (swatch) => swatch.tag_name?.toLowerCase() === "primarycolor--" + props.option.key.toLowerCase()
    );
  }, [props.swatches, props.option.key]);

  return (
    <Checkbox
      value={props.option.key}
      checked={props.option.checked}
      label={props.option.label.toLowerCase()}
      count={props.option.doc_count}
      onChange={props.onChange}
      hex={swatch?.colour}
      image={swatch?.image}
    />
  );
};
